import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated } from "utils/common";
import { getPlace } from "features/Place/placeSlice";
import { SERVICE } from "constants/global";
import ErrorDB from "components/ErrorDB";

function Place() {
  const dispatch = useDispatch();

  const { place, isInLine } = useSelector((state) => state.place);
  const data = place?.data;
  
  useEffect(() => {
    dispatch(getPlace({ service: SERVICE }));
  }, []);

  return (
    <div
      className={isAuthenticated() ? "w-80 py-0 py-md-3" : "container px-0"}
    >
    <div className="fs-20 fs-sm-18 fw-600 sp-14 text-center py-3 py-md-4">
      モニター説明会場
    </div>
    {isInLine ? <ErrorDB/> :
    data?.length > 0 && (
      <div className="px-3 py-3 bg-f4 bg-sm-grey border-radius-sm-none rounded-3 position-relative">
        <div className="px-0 px-md-1 py-2">
          {data.map((p) => (
            <a
              key={p.id}
              href={`/place/${p?.id}`}
              className="row gx-0 px-3 py-2 my-2 align-items-center rounded-3 bg-white"
            >
              <div className="col-11 col-md-10">
                <div className="row">
                  <div className="col-12 col-md-6 text-blue fs-16 fs-sm-14 fw-600 cursor-pointer">
                    {p?.name}
                  </div>
                  <div className="col-12 col-md-6 fs-14 fs-sm-12 fw-400">
                    {p?.address}
                  </div>
                </div>
              </div>
              <div className="view-more cursor-pointer col-1 col-md-2 d-flex justify-content-end align-self-center align-items-center">
                <span className="d-none d-md-block">詳細</span>
                <i className="bi bi-chevron-right"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    )}
    </div>
  );
}

export default Place;
